(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ReportTypeEnum', reportTypeEnumFactory);

  function reportTypeEnumFactory () {
    return Object.freeze({
      MONEY_BY_DATE_REPORT: 'MONEY_BY_DATE_REPORT',
      R2W_BY_DATE_REPORT: 'R2W_BY_DATE_REPORT',
      COINS_BY_DATE_REPORT: 'COINS_BY_DATE_REPORT',
      AVG_MONEY_BY_HOUR_REPORT: 'AVG_MONEY_BY_HOUR_REPORT',
      AVG_MONEY_BY_DAY_OF_WEEK_REPORT: 'AVG_MONEY_BY_DAY_OF_WEEK_REPORT',
      AVG_MONEY_BY_BOX_REPORT: 'AVG_MONEY_BY_BOX_REPORT',
      COMPARE_PERIODS_REPORT: 'COMPARE_PERIODS_REPORT',
      TOTAL_USERS_BY_GROUP: 'TOTAL_USERS_BY_GROUP',
      VISITS_COUNT_REPORT: 'VISITS_COUNT_REPORT',
      LOYALTY_PER_DAY_REPORT: 'LOYALTY_PER_DAY_REPORT',
      TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY: 'TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY',
      TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY: 'TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY',
      TOTAL_SPENT_LOCAL_TOKENS_PER_DAY: 'TOTAL_SPENT_LOCAL_TOKENS_PER_DAY',
      EUROKEY_BY_DATE_REPORT: 'EUROKEY_BY_DATE_REPORT',
      CHANGER_INCOME: 'CHANGER_INCOME',
      POS_INCOME: 'POS_INCOME'
    });
  }
})();
